var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.pagesCount > 1)?_c('v-pagination',{attrs:{"circle":"","length":_vm.pagesCount,"total-visible":7,"disabled":_vm.pending},model:{value:(_vm.page),callback:function ($$v) {_vm.page=$$v},expression:"page"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }